export const SHOWGALLERY='SHOWGALLERY';
export const INVITECAKE='INVITECAKE';
export const ADDTOCART='ADDTOCART';
export const REMOVEFROMCART='REMOVEFROMCART';
export const REDUCEFROMCART='REDUCEFROMCART';
export const ADDRETURN='ADDRETURN';
export const SHOWCART='SHOWCART';
export const ADDALLRETURN='ADDALLRETURN';
